export default {
  handle(topic) {
    console.log(topic)
  },
}
